import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import Logo from '../components/Logo';
import LanguageSelector from '../components/LanguageSelector';

const EmailConfirmed: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="absolute top-4 right-4">
        <LanguageSelector /> 
      </div>
      
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <Logo size="large" className="mx-auto mb-6" />
        
        <div className="flex justify-center mb-6">
          <CheckCircle className="h-16 w-16 text-green-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {t('emailConfirmed')}
        </h1>
        
        <p className="text-gray-600 mb-6">
          {t('emailConfirmedInstructions')}
        </p>
        
        <Link
          to="/login"
          className="block w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          {t('proceedToLogin')}
        </Link>
      </div>
    </div>
  );
};

export default EmailConfirmed;